// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Link, NavLink } from 'react-router-dom';
import SearchPage from './pages/SearchPage';
import ArticlesIndex from './pages/ArticlesIndex';
import ArticlePage from './pages/ArticlePage';

function NotFound() {
  return (
    <div className="max-w-3xl mx-auto text-center py-16">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Page not found</h1>
      <Link to="/" className="text-blue-600 hover:underline">← Back to search</Link>
    </div>
  );
}

const navLinkClass = ({ isActive }) =>
  `px-3 py-2 text-sm font-medium rounded-md ${
    isActive ? 'text-blue-800 bg-blue-50' : 'text-gray-600 hover:text-blue-800'
  }`;

function App() {
  return (
    <BrowserRouter>
      <div className="container mx-auto px-4 py-8">
        {/* Site navigation */}
        <nav className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
          <Link to="/" className="text-lg font-bold text-blue-800">
            <i className="fas fa-pills mr-2"></i>HealthSA
          </Link>
          <div className="flex space-x-2">
            <NavLink to="/" end className={navLinkClass}>
              <i className="fas fa-search mr-1"></i>Search
            </NavLink>
            <NavLink to="/articles" className={navLinkClass}>
              <i className="fas fa-book-open mr-1"></i>Articles
            </NavLink>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<SearchPage />} />
          <Route path="/articles" element={<ArticlesIndex />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Footer / Legal disclaimer */}
        <footer className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-500 space-y-2 text-center">
          <p className="font-medium text-gray-600">
            Independent, non-commercial reference tool. Not affiliated with, endorsed by, or acting on behalf of
            SAHPRA, the National Department of Health, or the Medicine Price Registry.
          </p>
          <p>
            All medicine, pricing, and registration data is sourced from publicly accessible databases
            (
            <a href="https://medicineprices.org.za/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">medicineprices.org.za</a>
            {' '}and{' '}
            <a href="https://www.sahpra.org.za/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">SAHPRA</a>
            ) and remains the property of its respective owners. No ownership of that data is claimed.
          </p>
          <p>
            Provided "as is" for informational purposes only, without warranty of any kind. This is not medical,
            pharmaceutical, or legal advice — data may be incomplete or out of date. Always verify against the
            official sources and consult a healthcare professional before making any decisions.
          </p>
          <p className="text-gray-400">
            Open source under the MIT License. To request removal or correction of any data, please open an issue on the project repository.
          </p>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
